import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { CruiseService } from '../services/cruise.service';
import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { PlatformLocation, isPlatformServer, isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-enquiry',
  templateUrl: './enquiry-success.component.html',
  styleUrls: []
})
export class EnquiryComponent implements OnInit {

  public queryData = {
    userlogin: '',
    dateupto: ''
  };

  public pipe: DatePipe = new DatePipe('en-US');
  private baseURL: any = ''; private merchantURL: any = '';
  private merchantsetup: any = {};
  private systemsetup: any = {};
  private queryStr: any = '';
  private useremail: any = ''; public otpCode: any = ''; private profileData: any = {};

  constructor(@Inject(PLATFORM_ID) private platformId: Object, private loginService: CruiseService, private toastr: ToastrService, private route: ActivatedRoute, private router: Router, platformLocation: PlatformLocation) {
    this.route.queryParams.subscribe(
      data => {
        console.log(data);
        this.queryData.userlogin = data.userlogin; this.queryData.dateupto = data.dateupto;
        this.queryStr = data.userlogin;
      });

    if (isPlatformBrowser(this.platformId)) { sessionStorage.clear(); localStorage.clear(); }
    // var merchantdata = this.route.snapshot.data['merchantsetup'];
    // var staticdata = this.route.snapshot.data['staticdata'];
    // this.merchantsetup = JSON.parse(JSON.parse(JSON.parse(JSON.stringify(merchantdata.d))).merchantsetup)
    // this.systemsetup = JSON.parse(JSON.parse(JSON.stringify(staticdata.d)));
  }

  ngOnInit() {

    if (isPlatformBrowser(this.platformId)) { sessionStorage.clear(); localStorage.clear(); }

    this.loginService.getProfile(this.queryData.userlogin, this.queryData.dateupto).subscribe(data => {
      this.profileData = JSON.parse(JSON.stringify(data)).d;

      if (isPlatformBrowser(this.platformId)) {
        sessionStorage.setItem("logindata", JSON.stringify(this.profileData));
        sessionStorage.setItem("isAgentLoggedIn", "true");
        sessionStorage.setItem("loginType", "B2B");
      }
      this.router.navigate([""]);
    }, error => console.log(error));

  }
}
